module.exports = __webpack_public_path__ + "media/images/flags/64/Mayotte-e7d2a21c47720cfe78db197295df67f1.png";